import ComponentInitializer from '../libs/component-initializer.js';
import ComponentBase from './base/component-base.js';

class Hero extends ComponentBase {

  private count: number = 0;
  private imgItems: HTMLElement[];

  constructor(element: HTMLElement) {
    super(element);
    this.imgItems = Array.from(this.element.querySelectorAll('.js-hero-img-item'));
    setTimeout(() => {
      this.start();
    }, 1000);
  }

  private start(){
    this.element.classList.add('is-ready');
    this.wait();
  }

  private wait(){
    setTimeout(() => {
      this.changeImg();
    }, 4000);
  }

  private changeImg(){
    this.count++;
    if(this.count >= this.imgItems.length){
      this.count = 0;
    }
    this.imgItems.forEach((imgItem) => {
      imgItem.classList.remove('is-current');
    });
    this.imgItems[this.count].classList.add('is-current');
    this.wait();
  }
}

ComponentInitializer.initializeComponent('.js-hero', Hero);